import React, {memo, useState} from "react";
import {useTranslation} from "react-i18next";
//local
import SubHeading from "components/SubHeading";
import CustomRadioSwitch from "components/CustomRadioSwitch";
import {showError, showSuccess} from "helpers/notifications.helper";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {DepartmentLabelModal} from "components/modals/DepartmentLabelModal";
import {ConfirmModal} from "components/ConfirmModal";
import {IconLabel, IconPlus, IconCog} from "components/icons";

const DepartmentSettings = memo(
  ({
    settings,
    departments,
    isOwner,
    getLabels,
    createLabel,
    updateLabel,
    removeLabel,
    onUpdate,
  }) => {
    const {t} = useTranslation();

    const [isDepartmentLabel, setIsDepartmentLabel] = useState(null);
    const [loadingChangeDepartmentLabel, setLoadingChangeDepartmentLabel] =
      useState(false);

    const handleSaveDepartmentLabel = async (name) => {
      try {
        setLoadingChangeDepartmentLabel(true);
        isDepartmentLabel?.id
          ? await updateLabel(isDepartmentLabel.id, {
              name,
            })
          : await createLabel({name});
        setIsDepartmentLabel(null);
        showSuccess(
          isDepartmentLabel?.id ? t("SUCCESSFULLY_UPDATED") : t("SUCCESSFULLY_CREATED")
        );
        getLabels();
      } finally {
        setLoadingChangeDepartmentLabel(false);
      }
    };

    const handleRemoveDepartmentLabel = () =>
      ConfirmModal({
        title: t("WANT_DELETE_DEPARTMENT_LABEL"),
        text: t("CANT_DELETE_DEPARTMENT_LABEL"),
        type: "warning",
        onOk: () => {
          setLoadingChangeDepartmentLabel(true);
          removeLabel(isDepartmentLabel.id)
            .then(() => {
              setIsDepartmentLabel(null);
              showSuccess(t("SUCCESSFULLY_REMOVED"));
              getLabels();
            })
            .finally(() => setLoadingChangeDepartmentLabel(false));
        },
      });

    return (
      <>
        <div className="organization-settings__department-labels mb-12">
          <SubHeading title="DEPARTMENTS" icon={<IconLabel />} />
          <CustomRadioSwitch
            checked={settings?.useDepartmentsForProjects}
            mediumText
            label={t("DEPARTMENTS_SWITCH_LABEL")}
            small
            addWrapperClass="mt-4"
            informationText="DEPARTMENTS_SWITCH_TOOLTIP"
            isActive={(checked) => onUpdate({useDepartmentsForProjects: checked})}
          />
          <div className="df-row-center mt-4">
            {!!departments?.length &&
              departments.map((department) => (
                <ButtonTransparent
                  addClass="organization-settings__department-labels__department-button __rotate-on-hover"
                  key={department.id}
                  name={department.name}
                  small
                  rounded
                  uppercase
                  color="black"
                  iconRight={<IconCog />}
                  onIconClick={() =>
                    isOwner
                      ? setIsDepartmentLabel(department)
                      : showError("WRONG_PRIVILEGES_ONLY_OWNER")
                  }
                />
              ))}
            <ButtonTransparent
              addClass="organization-settings__department-labels__add-button"
              name="SETTINGS_ORGANIZATION_DEPARTMENTS_ADD_BUTTON"
              small
              rounded
              color="black"
              icon={<IconPlus />}
              onClick={() =>
                isOwner
                  ? setIsDepartmentLabel({})
                  : showError("WRONG_PRIVILEGES_ONLY_OWNER")
              }
            />
          </div>
        </div>
        {isDepartmentLabel && (
          <DepartmentLabelModal
            department={isDepartmentLabel}
            onSave={handleSaveDepartmentLabel}
            onRemove={handleRemoveDepartmentLabel}
            onClose={() => setIsDepartmentLabel(null)}
            loading={loadingChangeDepartmentLabel}
          />
        )}
      </>
    );
  }
);

export default DepartmentSettings;
